/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsBCSQuestionsSeedRequest {
    getFixupPrototypeFunction() { return AppSecopsBCSQuestionsSeedRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsBCSQuestionsSeedRequest>): AppSecopsBCSQuestionsSeedRequest {
        let obj = Object.assign(new AppSecopsBCSQuestionsSeedRequest(), model);
        AppSecopsBCSQuestionsSeedRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsBCSQuestionsSeedRequest>): AppSecopsBCSQuestionsSeedRequest {
        if (!model) return null;
        return AppSecopsBCSQuestionsSeedRequest.newInstance(<AppSecopsBCSQuestionsSeedRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsBCSQuestionsSeedRequest) {
        if (!obj) return;

        models.AppSecopsBCSQuestionsSeedRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsBCSQuestionsSeedRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsBCSQuestionsSeedRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

}
